import { render, staticRenderFns } from "./ModalRoot.vue?vue&type=template&id=5a3d7330&scoped=true&"
import script from "./ModalRoot.vue?vue&type=script&lang=js&"
export * from "./ModalRoot.vue?vue&type=script&lang=js&"
import style0 from "./ModalRoot.vue?vue&type=style&index=0&id=5a3d7330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3d7330",
  null
  
)

export default component.exports